import { useId } from "react";
import type { ClinicalIconProps } from "./shared";
import { ClinicalIconSvg, FillPath, StrokePath } from "./shared";

export function IconCrown(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
    </ClinicalIconSvg>
  );
}

export function IconInlayOnlay(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      <FillPath d="M10.4 6.6h3.2a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1h-3.2a1 1 0 0 1-1-1v-2a1 1 0 0 1 1-1z" />
    </ClinicalIconSvg>
  );
}

export function IconBridge(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM8.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM15.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M1.5 13.2C1.5 17.54 2.2 20.2 3.25 20.2C4.16 20.2 4.44 16.7 5 16.7C5.56 16.7 5.84 20.2 6.75 20.2C7.8 20.2 8.5 17.54 8.5 13.2" />
      <StrokePath d="M15.5 13.2C15.5 17.54 16.2 20.2 17.25 20.2C18.16 20.2 18.44 16.7 19 16.7C19.56 16.7 19.84 20.2 20.75 20.2C21.8 20.2 22.5 17.54 22.5 13.2" />
    </ClinicalIconSvg>
  );
}

export function IconVeneer(props: ClinicalIconProps) {
  const clipId = useId();

  return (
    <ClinicalIconSvg {...props}>
      <clipPath id={clipId}>
        <rect x="0" y="0" width="12" height="24" />
      </clipPath>
      <FillPath
        d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z"
        clipPath={`url(#${clipId})`}
      />
      <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
    </ClinicalIconSvg>
  );
}

export function IconInlayCore(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      <StrokePath d="M8.4 10v9.4" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconCrownOnInlayCore(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <FillPath d="M5 13.2v-3.92a7 4.48 0 0 1 14 0v3.92z" />
      <StrokePath d="M5 13.2C5 18.41 6.4 21.6 8.5 21.6C10.32 21.6 10.88 17.4 12 17.4C13.12 17.4 13.68 21.6 15.5 21.6C17.6 21.6 19 18.41 19 13.2" />
      <StrokePath d="M8.4 10v9.4" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconBridgeOnInlayCore(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM8.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM15.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M5 13.2v6" strokeWidth="2.6" />
      <StrokePath d="M19 13.2v6" strokeWidth="2.6" />
    </ClinicalIconSvg>
  );
}

export function IconSplintedCrown(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM12 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M5 13.2C5 17.54 5.7 20.2 6.75 20.2C7.66 20.2 7.94 16.7 8.5 16.7C9.06 16.7 9.34 20.2 10.25 20.2C11.3 20.2 12 17.54 12 13.2" />
      <StrokePath d="M12 13.2C12 17.54 12.7 20.2 13.75 20.2C14.66 20.2 14.94 16.7 15.5 16.7C16.06 16.7 16.34 20.2 17.25 20.2C18.3 20.2 19 17.54 19 13.2" />
    </ClinicalIconSvg>
  );
}

export function IconMixedBridge(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <StrokePath d="M1.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM8.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96zM15.5 13.2v-1.96a3.5 2.24 0 0 1 7 0v1.96z" />
      <StrokePath d="M1.5 13.2C1.5 17.54 2.2 20.2 3.25 20.2C4.16 20.2 4.44 16.7 5 16.7C5.56 16.7 5.84 20.2 6.75 20.2C7.8 20.2 8.5 17.54 8.5 13.2" />
      <StrokePath d="M19 13.2v7.2M17.2 14.8h3.6M17.2 16.8h3.6M17.7 18.8h2.6" />
    </ClinicalIconSvg>
  );
}

export function IconPonticSaddle(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g color="var(--mantine-color-rose-4)">
        <FillPath d="M1 21C4.5 21 7 15 12 15S19.5 21 23 21V23H1Z" />
      </g>
      <StrokePath
        fill="white"
        d="M5.5 17.6V7a6.5 4 0 0 1 13 0v10.6C16.2 15.6 14.4 15 12 15S7.8 15.6 5.5 17.6Z"
      />
    </ClinicalIconSvg>
  );
}

export function IconPonticModifiedRidge(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g color="var(--mantine-color-rose-4)">
        <FillPath d="M1 21C4.5 21 7 15 12 15S19.5 21 23 21V23H1Z" />
      </g>
      <StrokePath
        fill="white"
        d="M6 13V7a6 4 0 0 1 12 0v10C16.4 15.6 14.6 15 12 15C10 13.7 8.2 13 6 13Z"
      />
    </ClinicalIconSvg>
  );
}

export function IconPonticOvate(props: ClinicalIconProps) {
  return (
    <ClinicalIconSvg {...props}>
      <g color="var(--mantine-color-rose-4)">
        <FillPath d="M1 21C4.5 21 6.2 15 9 15C10.4 15 10.6 18.4 12 18.4S13.6 15 15 15C17.8 15 19.5 21 23 21V23H1Z" />
      </g>
      <StrokePath
        fill="white"
        d="M6 12.6V7a6 4 0 0 1 12 0v5.6C18 15.6 15.4 18.4 12 18.4S6 15.6 6 12.6Z"
      />
    </ClinicalIconSvg>
  );
}
